// extracted by mini-css-extract-plugin
export default {"carousel-controls":"CarouselcControls_carousel-controls__LJFzZ","center":"CarouselcControls_center__SOZ+k"};